import { FXAAEffect } from 'postprocessing';

import { wrapEffect } from './wrapEffect.js';

export const FXAA = wrapEffect(FXAAEffect);
